import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "../utils/Auth";

// handle the public routes
function PublicRoute({ component: Component, ...rest }) {
  return (

    <Route
      {...rest}
      render={(props) =>
        !getToken() ? (
          <Component {...props} />
        ) : (
          props.match.url.split("/")[1] == "courseinfo" ?
            <Component {...props} /> :
            <Redirect to={{ pathname: "/home" }} />
        )
      }
    />
  );
}

export default PublicRoute;